import { useEffect, useState } from 'react';

export declare type OperatingSystem = 'windows' | 'macos' | 'linux' | 'unknown' | 'unset';

/**
 * TODO: 간단하게 윈도우 확인용으로 작성했기에 그 외 운영체제 확인에 사용하기 위해서는 수정이 필요
 */
const useDetectOs = () => {
  const [os, setOS] = useState<OperatingSystem>('unset');

  useEffect(() => {
    const platform = window.navigator.userAgent?.toLowerCase();

    if (platform.includes('win')) {
      setOS('windows');
      return;
    }
    if (platform.includes('mac')) {
      setOS('macos');
      return;
    }
    if (platform.includes('linux')) {
      setOS('linux');
      return;
    }
    setOS('unknown');
  }, []);

  return os;
};

export default useDetectOs;
